import { getDefaultState } from './state'

const mutations = {
  resetState(state: any): void {
    Object.assign(state, getDefaultState())
  }
}

export default {
  ...mutations
}
